module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/257.8cac01d1.png";